import React from 'react';

import Img from 'retired/Img';

export const SummaryCardImage = ({ alt, src, color }: SummaryCardImageProps) => (
  <div
    style={{
      backgroundColor: color,
      width: '100%',
      height: 143,
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 12,
    }}
  >
    <Img src={src} alt={alt} />
  </div>
);
interface SummaryCardImageProps {
  src: string;
  color: string;
  alt?: string;
}
